import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Mail } from 'lucide-react';

import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui/Button';
import { Input, Field } from '@/components/ui/Input';
import { useToast } from '@/components/ui/Toast';

import { api } from '@/lib/api';
import { AuthSplitLayout } from './Login';

export default function ForgotPassword() {

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const { toast } = useToast();

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const { data } = await api.post(
        '/auth/forgot-password',
        { email }
      );

      toast({
        title: 'Reset Link Sent',
        description: data.message,
        variant: 'success',
      });

    } catch (err) {

      toast({
        title: 'Request Failed',
        description:
          err.response?.data?.detail ||
          'Something went wrong',
        variant: 'destructive',
      });

    } finally {

      setLoading(false);
    }
  };

  return (
    <AuthSplitLayout mode="customer">

      <div className="lg:hidden mb-10">
        <Logo />
      </div>

      <div className="text-[10px] uppercase tracking-[0.25em] text-volt mb-3">
        Password Recovery
      </div>

      <h1 className="font-heading font-black text-4xl sm:text-5xl uppercase tracking-tight leading-none">
        Reset your<br />password.
      </h1>

      <p className="mt-3 text-white/50 text-sm">
        Enter your registered email address and we'll send you a secure reset link.
      </p>

      <form
        onSubmit={handleSubmit}
        className="mt-10 space-y-5"
      >

        <Field label="Email Address" htmlFor="email">

          <div className="relative">

            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              className="pr-12"
            />

            <Mail
              size={16}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40"
            />

          </div>

        </Field>

        <Button
          type="submit"
          className="w-full"
          disabled={loading}
        >
          {loading ? (
            'Sending Reset Link…'
          ) : (
            <>
              Send Reset Link
              <ArrowRight size={16} />
            </>
          )}
        </Button>

        <div className="text-center pt-2">

          <Link
            to="/login"
            className="text-[10px] uppercase tracking-[0.25em] text-white/40 hover:text-volt"
          >
            ← Back to Login
          </Link>

        </div>

      </form>

    </AuthSplitLayout>
  );
}